import {
  CreatePickupOrderRequest,
  UpdateOrderRequest,
  OrderQueryParams,
} from '../types/order.type';
import { HttpMethods, makeRequest } from '../helpers/http.helper';

export const getOrders = (params?: OrderQueryParams) => {
  return makeRequest({
    url: '/pickup_order',
    method: HttpMethods.GET,
    params: params || {},
  });
};

export const getOrder = (orderId: string) => {
  return makeRequest({
    url: `/pickup_order/${orderId}`,
    method: HttpMethods.GET,
  });
};

export const createOrder = (order: CreatePickupOrderRequest) => {
  return makeRequest({
    url: '/pickup_order',
    method: HttpMethods.POST,
    data: order,
  });
};

export const updateOrder = (orderId: string, order: UpdateOrderRequest) => {
  return makeRequest({
    url: `/pickup_order/${orderId}`,
    method: HttpMethods.PUT,
    data: order,
  });
};

export const deleteOrder = (orderId: string) => {
  return makeRequest({
    url: `/pickup_order/${orderId}`,
    method: HttpMethods.DELETE,
  });
}; 